// ** React Imports
import { matchPath, Link } from "react-router-dom";

// ** Redux
import { useSelector } from "react-redux";

// ** Custom Components
import Pill from "components/layout/Pill";
import { ButtonRoundedHeader } from "components/layout/Button/ButtonRoundedHeader";

// ** Utils & Helpers
import numberShortcut from "helpers/numberShortcut";

// ** Styled Components
import { StyledHeaderButtonIcon } from "../../styles/HeaderButtonIcon.styled";

// ** SVG Static Imports
import { ReactComponent as RegularBell } from "resources/icons/regular/bell.svg";
import { ReactComponent as SolidBell } from "resources/icons/solid/bell-solid.svg";

// #####################################################;

const NotificationsButton = ({
	isUserFrozen,
	notificationsCount,
	locationPathname,
}) => {
	const isActive = matchPath(locationPathname, {
		path: "/userpanel/notifications",
	});

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);

	// #####################################################

	return (
		<Link
			to={
				isUserFrozen
					? "/userpanel/settings/account"
					: "/userpanel/notifications"
			}
		>
			<ButtonRoundedHeader
				active={isActive}
				label="Powiadomienia"
				style={{ zIndex: 3 }}
			>
				{isActive ? (
					<StyledHeaderButtonIcon
						type="fas"
						svgIconComponent={SolidBell}
						icon="bell-solid"
						color={isDarkMode ? "primaryLight" : "primary"}
					/>
				) : (
					<StyledHeaderButtonIcon
						type="far"
						svgIconComponent={RegularBell}
						icon="bell"
					/>
				)}
				{notificationsCount > 0 && (
					<Pill
						color="red"
						rightPosition={notificationsCount.toString().length > 2}
					>
						{numberShortcut(notificationsCount)}
					</Pill>
				)}
			</ButtonRoundedHeader>
		</Link>
	);
};

// #####################################################

export default NotificationsButton;

// #####################################################
